import { render, staticRenderFns } from "./outdoorRunningConfig.vue?vue&type=template&id=397cb7a5&scoped=true&"
import script from "./outdoorRunningConfig.vue?vue&type=script&lang=js&"
export * from "./outdoorRunningConfig.vue?vue&type=script&lang=js&"
import style0 from "./outdoorRunningConfig.vue?vue&type=style&index=0&id=397cb7a5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397cb7a5",
  null
  
)

export default component.exports